import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import i18n from '../../../../shared/locales/no.json';
import ProfileStatus from './../../../utils/ProfileStatus';
import { createUrl } from '../../../utils/createUrl';

class PreviewButton extends PureComponent {
    static propTypes = {
        id: PropTypes.number,
        status: PropTypes.string,
        onPreviewClick: PropTypes.func.isRequired,
    };

    _onClick() {
        this.props.onPreviewClick();
    }

    render() {
        if (!this.props.id) {
            return null;
        }

        const className =
            this.props.status === ProfileStatus.ACTIVE
                ? 'primary'
                : 'secondary';
        return (
            <a
                className={`button ${className}`}
                href={createUrl(`/company/${this.props.id}`)}
                id="preview-button"
                onClick={this._onClick.bind(this)}
            >
                {i18n.Preview}
            </a>
        );
    }
}

export default PreviewButton;
